export default "__VITE_ASSET__MAg7OG$$__"